export const PersistentStorage = {
	set(key, value) {
		try {
			localStorage.setItem(key, JSON.stringify(value));
		} catch (error) {
			console.error('PersistentStorage#set(): Unable to set entry for', key, error);
		}
	},
	get(key) {
		try {
			return JSON.parse(localStorage.getItem(key));
		} catch (error) {
			console.error('PersistentStorage#get(): Unable to get entry for', key, error);
		}
	},
	has(key) {
		return localStorage.getItem(key) !== null;
	},
	remove(key) {
		localStorage.removeItem(key);
	},
};
